import React, { ReactElement } from "react";
import { BsEye } from "react-icons/bs";

export const getIcon = (type) => {
  switch (type) {
    case "text":
      return undefined;
    case "password":
      return <BsEye />;
    case "phone":
      return undefined;
    case "number":
      return undefined;
    case "decimal":
      return undefined;
    case "email":
      return undefined;
    case "date":
      return undefined;
    default:
      return undefined;
  }
};
